export default __webpack_public_path__ + "static/media/floralServiceImg_01.51bd46af.jpg";